import { inject, Injectable } from '@angular/core';
import { isNil } from 'lodash';
import { Message, MessageService } from 'primeng/api';
import { AppResource } from 'src/app/app.resource';
export type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

@Injectable({ providedIn: 'root' })
export class VyvToastService {
  resource = inject(AppResource)['resource'];
  private messageService = inject(MessageService);

  constructor() {}

  show(severity: ToastSeverity, message: string, title: string | null, hasTitle: boolean = false): void {
    this.messageService.add(this.getToastConfig(severity, message, title, hasTitle));
  }

  getToastConfig(severity: ToastSeverity, message: string, title: string | null, hasTitle: boolean = false): Message {
    return {
      severity: severity,
      summary: !!hasTitle && !isNil(title) ? title : !!hasTitle ? this.resource.generic[severity] : undefined,
      detail: message,
      life: 50000,
    };
  }
}
